import { Assistant } from "./assistant/Assistant";

document.addEventListener("DOMContentLoaded", () => {
  const panel = document.getElementById("assistant-panel");
  if (panel) {
    new Assistant(panel);
  }

  // Collapsible floating widget: the video acts as the launcher when collapsed
  // and stays pinned to the top edge of the chat once expanded.
  const widget = document.getElementById("assistant-widget");
  const toggle = document.getElementById("assistant-toggle");
  const close = document.getElementById("assistant-close");
  const expand = document.getElementById("assistant-expand");
  const expandIcon = document.getElementById("assistant-expand-icon");
  const input = document.getElementById("assistant-text");

  if (widget && toggle) {
    const setMaximized = (max) => {
      widget.classList.toggle("assistant-widget--maximized", max);
      if (expandIcon) {
        expandIcon.classList.toggle("fa-expand", !max);
        expandIcon.classList.toggle("fa-compress", max);
      }
      if (expand) {
        expand.setAttribute("aria-label", max ? "Restore" : "Maximize");
      }
    };

    // Remember only the open/closed state across page navigation (never the maximized state — after a
    // page switch the panel always comes back compact, never as the big window).
    const OPEN_KEY = "assistant-open";

    const setOpen = (open) => {
      widget.classList.toggle("assistant-widget--collapsed", !open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      try {
        sessionStorage.setItem(OPEN_KEY, open ? "1" : "0");
      } catch (e) {
        /* sessionStorage may be unavailable (private mode) — the panel just won't persist its state. */
      }
      if (open) {
        if (input) {
          input.focus();
        }
      } else {
        setMaximized(false); // always restore to the compact size when closing
      }
    };

    toggle.addEventListener("click", () => {
      setOpen(widget.classList.contains("assistant-widget--collapsed"));
    });

    if (close) {
      close.addEventListener("click", () => setOpen(false));
    }

    if (expand) {
      expand.addEventListener("click", () => {
        setMaximized(!widget.classList.contains("assistant-widget--maximized"));
      });
    }

    // Restore the remembered open state on load (compact — the fresh page is never maximized).
    let wasOpen = false;
    try {
      wasOpen = sessionStorage.getItem(OPEN_KEY) === "1";
    } catch (e) {
      /* ignore */
    }
    if (wasOpen) {
      setOpen(true);
    }

    // If a conversation is still generating after a page switch, surface the panel (compact) so the
    // user sees the answer arrive. The Assistant dispatches this once it picks up a pending answer.
    if (panel) {
      panel.addEventListener("assistant:active", () => setOpen(true));
    }
  }
});
